import { ownerAutoCompleteItem } from "@rf/adapters/autocomplete-items/ownerItemAdapters";
import { OwnerAdapterCreateUpdate } from "@/private/modules/owners/adapter/update.form.adapter";
import { I_OwnersForm } from "@/src-refactor/modules/shared/components/forms/create-owners-form/util/for.util";
import { IItemGenericSchema } from "@rf/schemas/item-generic.shema";
import { IPropertyForm } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const prepareOwnersToServer = (body: IPropertyForm) => {
  const owners: {
    ids: number[];
    new: any[];
  } = {
    ids: [],
    new: []
  };
  const ownerList = body.owners_property as ownerAutoCompleteItem[];

  ownerList.forEach((owner: ownerAutoCompleteItem) => {
    console.log(owner);
    if (
      owner?.extraData?.ownerData?.formData == null ||
      owner?.extraData?.ownerData?.formData == undefined ||
      owner?.extraData?.ownerData?.formData == ""
    ) {
      owners.ids.push(Number((owner as IItemGenericSchema).value));
    } else {
      owners.new.push(
        OwnerAdapterCreateUpdate(owner.extraData?.ownerData.formData as I_OwnersForm)
      );
    }
  });

  return owners;
};

export default prepareOwnersToServer;
